import HomeHeader from "@/components/HomeHeader";
import Hero from "@/components/homepage/Hero";
import StorySection from "@/components/homepage/StorySection";
import LiveActivitySection from "@/components/homepage/LiveActivitySection";
import HowItWorksSection from "@/components/homepage/HowItWorksSection";
import BlogTeaserSection from "@/components/homepage/BlogTeaserSection";
import ShareSection from "@/components/homepage/ShareSection";
import CallToAction from "@/components/homepage/CallToAction";
import Footer from "@/components/homepage/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

const HOME_DESCRIPTION =
    "My Study Fund — turn paying for school into a shared journey. Students publish a Fund Page; friends and family give one-off or monthly support.";

export default function Home() {
    usePageMeta(undefined, HOME_DESCRIPTION);
    return (
        <div className="min-h-screen bg-white">
            <HomeHeader transparent />
            <Hero />
            <LiveActivitySection />
            <StorySection />
            <HowItWorksSection />
            <BlogTeaserSection />
            <ShareSection />
            <CallToAction />
            <Footer />
        </div>
    );
}
